import {
  Box,
  Heading,
  RadioGroup,
  RadioItem,
  Stack,
  TextField,
} from 'braid-design-system';

import { CheckboxGroup } from '../CheckboxGroup/CheckboxGroup';
import { LargestCustomers } from '../LargestCustomers';

import type { DetailsProps } from './Form';
import { useFormFields } from './useFormFields';

export const BusinessDetails = ({ setFieldValue }: DetailsProps) => {
  const {
    company,
    companyUrl,
    partnerType,
    seekRsp,
    recruitmentSoftware,
    numCustomers,
    customerSegment,
    largestCustomers,
  } = useFormFields();

  return (
    <Stack space="medium">
      <Box paddingTop="gutter">
        <Heading level="3">Business details</Heading>
      </Box>
      <TextField
        id="company"
        label="Company"
        onClear={() => setFieldValue('company', '')}
        message={!company.valid && company.errorMessage}
        tone={!company.valid ? 'critical' : 'neutral'}
        {...company}
      />
      <TextField
        id="companyUrl"
        label="Company website URL"
        onClear={() => setFieldValue('companyUrl', '')}
        message={!companyUrl.valid && companyUrl.errorMessage}
        tone={!companyUrl.valid ? 'critical' : 'neutral'}
        {...companyUrl}
      />
      <CheckboxGroup
        id="partnerType"
        label="Partner type"
        value={partnerType.value}
        columns={2}
        options={[
          'ATS',
          'Multiposter',
          'CRM',
          'HRIS',
          'SEEK customer',
          'Other',
        ]}
        error={!partnerType.valid}
        description="Please select at least one."
        onChange={partnerType.onChange}
      />
      <RadioGroup
        label="Are you a recruitment software provider wanting to integrate to SEEK?"
        id="seekRsp"
        {...seekRsp}
        onChange={({ currentTarget: { value } }) => {
          if (value === 'yes') {
            setFieldValue('recruitmentSoftware', '');
          }
          return seekRsp.onChange(value as 'yes' | 'no');
        }}
      >
        <RadioItem label="Yes" value="yes" />
        <RadioItem label="No" value="no" />
      </RadioGroup>
      {seekRsp.value === 'no' && (
        <TextField
          id="recruitmentSoftware"
          label="What recruitment software do you use?"
          onClear={() => setFieldValue('recruitmentSoftware', '')}
          message={
            !recruitmentSoftware.valid && recruitmentSoftware.errorMessage
          }
          tone={!recruitmentSoftware.valid ? 'critical' : 'neutral'}
          {...recruitmentSoftware}
          value={recruitmentSoftware.value || ''}
        />
      )}
      {seekRsp.value === 'yes' && (
        <>
          <TextField
            id="customerSegment"
            label="If you are a recruitment software provider, what is the primary customer segment your product serves?"
            onClear={() => setFieldValue('customerSegment', '')}
            message={!customerSegment.valid && customerSegment.errorMessage}
            tone={!customerSegment.valid ? 'critical' : 'neutral'}
            {...customerSegment}
            value={customerSegment.value || ''}
          />
          <TextField
            id="numCustomers"
            label="How many SEEK customers do you have?"
            onClear={() => setFieldValue('numCustomers', '0')}
            message={!numCustomers.valid && numCustomers.errorMessage}
            tone={!numCustomers.valid ? 'critical' : 'neutral'}
            type="number"
            {...numCustomers}
            value={numCustomers.value || ''}
          />
          {Number(numCustomers.value) > 0 && (
            <LargestCustomers
              customersLength={Number(numCustomers.value)}
              error={!largestCustomers.valid}
              id="largestCustomers"
              onChange={largestCustomers.onChange}
              rawValue={largestCustomers.value || ''}
            />
          )}
        </>
      )}
    </Stack>
  );
};
